import axios from '@/utils/request'

export default {
  // 2020-08-07
  findByCourierId(id) {
    return axios.get('/deliver-methods/find-by-courier-id/' + id)
  }
}

